import {
  ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS,
  FETCH_ALL_BUSINESS_UNIT_SUCCESS,
  FETCH_BUSINESS_UNIT_SUCCESS,
  FILTER_BUSINESS_UNIT,
  GET_ALL_BUSINESS_UNIT,
  GET_UNSELECTED_ALL_BUSINESS_UNIT,
  HANDLE_BUSINESS_UNIT_REQUEST_CLOSE,
  HIDE_BUSINESS_UNIT_LOADER,
  SHOW_BUSINESS_UNIT_LOADER,
  ON_ADD_BUSINESS_UNIT,
  ON_ALL_BUSINESS_UNIT_SELECT,
  ON_BUSINESS_UNIT_CLOSE,
  ON_BUSINESS_UNIT_SELECT,
  ON_DELETE_BUSINESS_UNIT_SUCCESS,
  ON_FILTER_SELECTED_BUSINESS_UNIT,
  ON_FILTER_BUSINESS_UNIT_OPTION_SELECT,
  ON_SAVE_BUSINESS_UNIT_SUCCESS,
  ON_TOGGLE_BUSINESS_UNIT_DRAWER,
  SHOW_BUSINESS_UNIT_MESSAGE,
  UPDATE_SEARCH_BUSINESS_UNIT,
  CLEAR_SESSION,
  CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All business units';
export const STARRED_FILTER = 'Starred business units';
export const SUCCESSFUL_UPDATE = 'Business Unit Updated Successfully';
export const SUCCESSFUL_FILTER = 'Business Unit Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Business Unit Deleted Successfully';
export const REMOVED_AS_STAR = 'Business Unit removed as star';
export const MARKED_AS_STAR = 'Business Unit marked as star';

export const INIT_STATE = {
  alertMessage: '',
  showMessage: false,
  loader: false,
  noContentFoundMessage: 'No business units found in selected folder',
  selectedSectionId: 1,
  drawerState: false,
  filterOption: ALL_FILTER,
  allBusinessUnit: [],
  businessUnitList: [],
  selectedBusinessUnit: null,
  selectedBusinessUnits: 0,
  addBusinessUnitState: false,
  searchBusinessUnit: '',
  businessUnit: {
      name: 'ACME Inc',
      email: 'road.runner@example.com',
      avatar: 'http://via.placeholder.com/150x150'
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
      case CLEAR_SESSION: {
          return {
            ...INIT_STATE,
          };
      }
      case CLEAR_SELECTED_OBJECTS: {
          return {
            ...state,
            selectedBusinessUnit: null,
          };
      }
      case ADD_FAVOURITE_BUSINESS_UNIT_SUCCESS: {
        const allUpdated = state.allBusinessUnit.map((entry) => entry ?.id === action ?.payload ?.id ? {
            ...entry,
            starred: !action ?.payload ?.starred
        } : entry);
        let listUpdated = {};
        switch (state.filterOption) {
            case ALL_FILTER: {
                listUpdated = allUpdated;
                break;
            }
            case STARRED_FILTER: {
                listUpdated = allUpdated.filter((entry) => entry.starred);
                break;
            }
        }
          return {
              ...state,
              alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
              showMessage: true,
              businessUnitList: listUpdated,
              allBusinessUnit: allUpdated,
          };
      }
      case FETCH_BUSINESS_UNIT_SUCCESS: {
          return {
              ...state,
              loader: false,
              selectedBusinessUnit: action.payload,
          };
      }
      case FETCH_ALL_BUSINESS_UNIT_SUCCESS: {
          return {
              ...state,
              loader: false,
              allBusinessUnit: action.payload,
              businessUnitList: action.payload,
              selectedSectionId: 1,
              searchEmp: '',
              filterOption: ALL_FILTER
          };
      }
      case SHOW_BUSINESS_UNIT_MESSAGE: {
          return {
              ...state,
              alertMessage: action.payload,
              showMessage: true,
              loader: false
          };
      }
      case ON_BUSINESS_UNIT_SELECT: {
          action.payload.selected = !action.payload.selected;
          let selectedBusinessUnits = 0;
          const businessUnitList = state.businessUnitList.map(businessUnit => {
              if (businessUnit.selected) {
                  selectedBusinessUnits++;
              }
              if (businessUnit.id === action.payload.id) {
                  if (businessUnit.selected) {
                      selectedBusinessUnits++;
                  }
                  return action.payload;
              } else {
                  return businessUnit;
              }
          }
          );
          return {
              ...state, INIT_STATE,
              selectedBusinessUnits: selectedBusinessUnits,
              businessUnitList: businessUnitList
          };
      }
      case ON_ADD_BUSINESS_UNIT: {
          return { ...state, addBusinessUnitState: true };
      }
      case ON_BUSINESS_UNIT_CLOSE: {
          return { ...state, addBusinessUnitState: false };
      }
      case ON_FILTER_BUSINESS_UNIT_OPTION_SELECT: {
          let selectedSectionId = 0;
          let filterOption = '';
          let businessUnitList = [];
          switch (action.payload.name) {
              case ALL_FILTER: {
                  selectedSectionId = action.payload.id;
                  filterOption = action.payload.name;
                  businessUnitList = state.allBusinessUnit;
                  break;
              }
              case STARRED_FILTER: {
                  selectedSectionId = action.payload.id;
                  filterOption = action.payload.name;
                  businessUnitList = state.allBusinessUnit.filter((businessUnit) => businessUnit.starred);
                  break;
              }
          }
          return {
              ...state, selectedSectionId, filterOption, businessUnitList, drawerState: false
          };
      }
      case ON_SAVE_BUSINESS_UNIT_SUCCESS: {
          return {
              ...state,
              alertMessage: SUCCESSFUL_UPDATE,
              showMessage: true,
              businessUnitList: addOrUpdateEntry(state.businessUnitList, action.payload),
              allBusinessUnit: addOrUpdateEntry(state.allBusinessUnit, action.payload),
              loader: false,
          };
      }
      // called after a delete from the db operation to keep the current state up to date
      case ON_DELETE_BUSINESS_UNIT_SUCCESS: {
          return {
              ...state,
              alertMessage: SUCCESSFUL_DELETE,
              showMessage: true,
              allBusinessUnit: state.allBusinessUnit.filter((businessUnit) => businessUnit.id !== action.payload),
              businessUnitList: state.allBusinessUnit.filter((businessUnit) => businessUnit.id !== action.payload),
              selectedBusinessUnit: null,
          };
      }
      case ON_FILTER_SELECTED_BUSINESS_UNIT: {
          const businessUnits = state.allBusinessUnit.filter((businessUnit) => !businessUnit.selected);
          return {
              ...state,
              alertMessage: SUCCESSFUL_FILTER,
              showMessage: true,
              businessUnitList: businessUnits,
              selectedBusinessUnits: 0
          };
      }
      case FILTER_BUSINESS_UNIT: {
          const { filterOption } = state;
          let businessUnitList = [];
          if (action.payload === '') {
              businessUnitList = state.allBusinessUnit;
          } else {
              const filterBusinessUnit = state.allBusinessUnit.filter((businessUnit) =>
                  businessUnit.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
              if (filterOption === ALL_FILTER) {
                  businessUnitList = filterBusinessUnit;
              } else if (filterOption === STARRED_FILTER) {
                  businessUnitList = filterBusinessUnit.filter((businessUnit) => businessUnit.starred);
              }
          }
          return { ...state, businessUnitList: businessUnitList };
      }
      case GET_ALL_BUSINESS_UNIT: {
          let businessUnitList = state.allBusinessUnit.map((businessUnit) => businessUnit ? {
              ...businessUnit,
              selected: true
          } : businessUnit);
          return {
              ...state,
              selectedBusinessUnits: businessUnitList.length,
              allBusinessUnit: businessUnitList,
              businessUnitList: businessUnitList
          };
      }
      case GET_UNSELECTED_ALL_BUSINESS_UNIT: {
          let businessUnitList = state.allBusinessUnit.map((businessUnit) => businessUnit ? {
              ...businessUnit,
              selected: false
          } : businessUnit);
          return {
              ...state,
              selectedBusinessUnits: 0,
              allBusinessUnit: businessUnitList,
              businessUnitList: businessUnitList
          };
      }
      case ON_ALL_BUSINESS_UNIT_SELECT: {
          const selectAll = state.selectedBusinessUnits < state.businessUnitList.length;
          let selectedBusinessUnits = 0;
          let businessUnitList = [];
          if (selectAll) {
              businessUnitList = state.allBusinessUnit.map((businessUnit) => businessUnit ? {
                  ...businessUnit,
                  selected: true
              } : businessUnit);
              selectedBusinessUnits = businessUnitList.length;
          } else {
              businessUnitList = state.allBusinessUnit.map((businessUnit) => businessUnit ? {
                  ...businessUnit,
                  selected: true
              } : businessUnit);
              selectedBusinessUnits = 0;
          }
          return {
              ...state,
              selectedBusinessUnits: selectedBusinessUnits,
              allBusinessUnit: businessUnitList,
              businessUnitList: businessUnitList
          };
      }
      case UPDATE_SEARCH_BUSINESS_UNIT: {
          return { ...state, searchBusinessUnit: action.payload };
      }
      case HANDLE_BUSINESS_UNIT_REQUEST_CLOSE: {
          return { ...state, showMessage: false };
      }
      case ON_TOGGLE_BUSINESS_UNIT_DRAWER: {
          return { ...state, drawerState: !state.drawerState };
      }
      case SHOW_BUSINESS_UNIT_LOADER: {
          return { ...state, loader: true };
      }
      case HIDE_BUSINESS_UNIT_LOADER: {
          return { ...state, loader: false };
      }

      default:
          return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/businessUnit.js